export default "__VITE_ASSET__B$YhPVqV__"